import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { getOtrosFuncionarios, getItemMenu } from "../../assets/js/api";
import { domain } from "../../assets/js/api";
import fotoPlaceHolder from "../../assets/img/placeholder@2x.jpg";
import { translate } from "../../assets/js/functions";

export default function OtrosFuncionarios({ section_id }) {
    const location = useLocation();
    const [otrosFuncionarios, setOtrosFuncionarios] = useState(null);
    const [item, setItem] = useState(location.state?.item || null);



    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);

    useEffect(() => {

        if (item) {
            getOtrosFuncionarios(item).then((data) => {
                setOtrosFuncionarios(data);
            });

        }
    }, [item]);



    const createTitle = (title) => {
        const words = title.split(" ");

        if (words.length >= 2) {
            words[words.length - 1] = (
                <span className="has-text-primary">{words[words.length - 1]}</span>
            );
        }

        return (
            <>
                {words.map((word, index) => (
                    <React.Fragment key={index}>
                        {word}
                        {index < words.length - 1 && ' '}
                    </React.Fragment>
                ))}
            </>
        );
    };

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header />
                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--l">
                        <h1 className="has-text-centered">
                            {item ? createTitle(item.term) : ""}
                        </h1>
                        <p className="px-6 mb-6">
                    </p>
                        {item ? (
                            <p className="has-text-centered">
                                {item.abstract}
                            </p>
                        ) : ''}
                    </div>
                    <div className="wrapper flow--l mt-7">
                        <div className="fotos columns is-multiline is-mobile is-centered">
                            {otrosFuncionarios ? (
                                <>
                                    {otrosFuncionarios.map((caso) => (
                                        <div key={"caso_" + caso.section_id} className="column is-6-mobile is-4-tablet is-2-desktop">
                                            <Link to={`/otros-funcionarios-represaliados/ficha/${caso.section_id}`}>
                                                {caso.image && Array.isArray(caso.image) && caso.image.length > 0 && caso.image[0].image ? (
                                                    <img
                                                        loading="lazy"
                                                        src={domain + caso.image[0].image}
                                                        alt=""
                                                        width="252"
                                                        height="287"
                                                    />
                                                ) : (
                                                    <img
                                                        loading="lazy"
                                                        src={fotoPlaceHolder}
                                                        alt=""
                                                        width="252"
                                                        height="287"
                                                    />
                                                )}
                                            </Link>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <div className="loader1">
                                    <div></div>
                                </div>
                            )}
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </Layout>
    );
}
